import styled, { css } from '@mint-lib/styled';

import { Box } from '@myn/mui';

const AutocompleteWrapper = styled(Box)<{ $scale: number }>`
  width: 100%;
  height: 100%;

  & > div {
    height: 100%;
  }
  .MuiAutocomplete-root {
    min-width: unset;
    width: 100%;
    height: 100%;
  }
  .MuiAutocomplete-root:hover .MuiAutocomplete-endAdornment,
  .MuiAutocomplete-root.Mui-focused .MuiAutocomplete-endAdornment {
    display: flex;
    align-items: center;
    background: inherit;
    height: ${({ $scale }) => ($scale === 1 ? '90%' : 'unset')};
  }
  .MuiAutocomplete-root > div {
    height: 100%;
  }
  .MuiTextField-root {
    height: 100%;
  }
  .MuiInputBase-root {
    min-height: unset;
    height: 100%;
    font-size: ${({ $scale }) => 0.875 * $scale}rem;
  }

  .MuiAutocomplete-inputRoot .MuiAutocomplete-endAdornment .MuiButtonBase-root {
    ${({ $scale }) => css`
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: ${24 * $scale}px;
      height: ${24 * $scale}px;
      svg {
        width: ${16 * $scale}px;
        height: ${16 * $scale}px;
      }
    `}
  }
`;

export default AutocompleteWrapper;
